// copy to clipboard
// window.ClipboardJS = require('clipboard');

// I need to do this dance as bootstrap assumes window.jQuery exists and we want it to point to our
// specific jQuery version. However, the wordpress site has its own dependency on a specific jQuery
// being set at window.jQuery. Backbone does the right thing, but bootstrap is a bad citizen.
var pageJQuery = window.jQuery;
window.jQuery = window.$ = require('jquery');

// require('bootstrap');
// require('velocity-animate');

// more bootstrap hackz; since we're adding our own jquery to the page, we were double registering handlers for the collapse
// plugin, resulting in wacky behavior on the menu on mobile. Let's remove that event handling here since the report does
// not use that plugin.
try {
    pageJQuery(function() {
        pageJQuery(document).off('click.bs.collapse.data-api');
    });
} catch (ex) {
    // ignore
}

window._ = require('lodash');

// create the jade templates
window.jade = require('../node_modules/jade/runtime.js');

var __setupJadeTemplates = require('./_signup_templates.js');
var div = document.createElement('div');
div.innerHTML = __setupJadeTemplates({});
document.body.appendChild(div);

window.Backbone = require('backbone');
window.Marionette = require('backbone.marionette');
window.Marionette.TemplateCache.prototype.compileTemplate = function (rawTemplate, options) {
    return window._.template(rawTemplate, options);
};

window.showRivalIQSignupForm = function (elSelector, signupConfigValues) {

    function showSignupForm() {
        const sfv = Marionette.TemplateCache.get('#signupFormView');
        const $el = $(elSelector);

        $el.append(sfv());

        RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.ViewedSignupPage);

        const data = _.pick(signupConfigValues, 'hubspotutk', 'pageName', 'pageUrl', 'accountGroupId', 'emailFieldLabel', 'prefillCompanyTitle', 'prefillCompanyName', 'prefillCompanyType');
        const App = RivalIQ.apps.Site;
        const signupForm = new App.views.SignupForm({
            el: elSelector,
            model: new App.models.Signup(data)
        }).render();

        signupForm.show();
    }

    window.rivalIqSettings = {
        showPhoneNumberField: false
    };

    const server = _.get(window.RivalIQEnv, ['urlBasepath']);
    $.ajax({
        type: 'GET',
        url: `${server}/signup-config`,
        crossdomain: true,
        timeout: 1000, // don't wait too long for this info; if it takes more than a second, just move on with rendering.
        error: function () {
            showSignupForm();
        },
        success: function (signupConfig) {
            window.rivalIqSettings = {
                showPhoneNumberField: signupConfig.showPhoneNumberField || false
            };

            showSignupForm();
        }
    });
};

window.RivalIQEnv = require('./_signup_environment.js');

// setup the app
require('../public/apps/site/includes.js');

if (window.RivalIQEnv.useRollbar) {
    const rollbarScript = document.createElement('script');
    rollbarScript.textContent = $('#rollbarIncludeTemplate').html();
    document.head.appendChild(rollbarScript);
}

window.jQuery = window.$ = pageJQuery;

